import React from 'react';
import { RichTableState, SortState } from './types';

export type UseRichTableStateArgs = {
    defaultSort?: SortState;
};

export const useRichTableState = ({ defaultSort }: UseRichTableStateArgs = {}): [
    RichTableState,
    (newState: RichTableState) => void,
] => {
    const [state, setState] = React.useState({
        searchValue: '',
        columnFilters: {},
        sortState: defaultSort,
        selectedRowKeys: [] as string[],
    });

    return [state, setState];
};
